import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (folder) =>
    present(
      repository
        .removeFolder(folder)
        .then(() => folder)
        .catch(() => Promise.reject(folder)),
    );
}

export type { Interactor };

export { createInteractor };
